import { apiGet } from "./client";

export type AuditEvent = {
  id: string;
  action: string;
  label: string;
  docType: string | null;
  docId: string | null;
  summary: string | null;
  payload: unknown;
  actorUserId: string | null;
  actorLabel: string;
  createdAt: string;
};

export type AuditListPage = {
  events: AuditEvent[];
  hasMore?: boolean;
  nextCursor?: string | null;
  total?: number;
};

export type AuditListSort = "createdAt" | "action" | "docType";

export function listAuditEvents(
  companyRef: string,
  opts?: {
    docType?: string;
    docId?: string;
    action?: string;
    actorUserId?: string;
    limit?: number;
    cursor?: string | null;
    sort?: AuditListSort;
    sortDir?: "asc" | "desc";
  },
) {
  const q = new URLSearchParams();
  if (opts?.docType) q.set("docType", opts.docType);
  if (opts?.docId) q.set("docId", opts.docId);
  if (opts?.action) q.set("action", opts.action);
  if (opts?.actorUserId) q.set("actorUserId", opts.actorUserId);
  if (opts?.limit != null) q.set("limit", String(opts.limit));
  if (opts?.cursor) q.set("cursor", opts.cursor);
  if (opts?.sort && opts.sort !== "createdAt") q.set("sort", opts.sort);
  if (opts?.sortDir) q.set("sortDir", opts.sortDir);
  const qs = q.toString();
  return apiGet<AuditListPage>(
    `/c/${companyRef}/audit${qs ? `?${qs}` : ""}`,
  );
}
